import { KeyOf } from '~/types';
import { colors } from './colors';

export const stroke = {
  stroke_1: colors.whiteAlpha20,
  stroke_2: colors.whiteAlpha60,
} as const;

export type Stroke = typeof stroke;
export type StrokeKeys = KeyOf<typeof stroke>;
